import { Component, OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import * as jsonManager from '../../../abis/Manager.json';
import { environment } from '../../../../environments/environment';
import { ConnectionsService } from '../../../services/connectionsWeb3/connections.service';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { AngularFirestore, DocumentData } from '@angular/fire/compat/firestore';
import firebase from 'firebase/compat/app';
import { PaymentService } from '../../../services/payment.service';

@Component({
  selector: 'app-buy-through-company',
  templateUrl: './buy-through-company.component.html',
  styleUrls: ['./buy-through-company.component.css']
})
export class BuyThroughCompanyComponent implements OnInit {
  formBuyThroughCompany: FormGroup = this.createFormBuyThroughCompany();

  ourAddress: string | undefined;
  web3: any | undefined;
  abiManager: any = jsonManager;
  contractManager: any | undefined;
  availableTokens: { tokensAddress: string; nameTokens: string; sellerAddress?: string }[] = [];
  tokenToSellerMap: { [tokenAddress: string]: string } = {};
  mappingId = new Map();
  externalCheck: string = '';
  isExternalChecked: boolean = false;
  externalCanReserve: boolean = false;
  nonExternalCanProceed: boolean = true;
  externalCheckResult: any = null;
  readonly investmentTypeExternal = 'external';
  readonly investmentTypeFailedMint = 'failed-mint';
  readonly investmentTypeNoChargeTx = 'no-charge-tx';
  readonly investmentTypeForcedTransferResend = 'forced-transfer-resend';

  get showPrivateSaleCheckbox(): boolean {
    const type = this.investmentType?.value;
    return type === this.investmentTypeExternal || type === this.investmentTypeNoChargeTx;
  }

  constructor(private connSrv: ConnectionsService, private fns: AngularFireFunctions, private afs: AngularFirestore, private paymentService: PaymentService) {
    this.web3 = this.connSrv.web3Instance;

    this.connSrv.addressUser.subscribe((res: string) => {
      this.ourAddress = res;
    });

    this.contractManager = new this.web3.eth.Contract(this.abiManager.abi, environment.config.ADDRESS_MANAGER);
  }

  ngOnInit(){
    this.loadTokens();

    // Listener para actualizar addressContractSeller cuando cambia tokenAddress
    this.amountTokens?.valueChanges.subscribe(tokens => {
      console.log('Tokens:', tokens);
      this.onChangeInvestmentType({ target: { value: this.investmentType?.getRawValue() } });
    });
    this.emailUser?.valueChanges.subscribe(email => {
      console.log('Email seleccionado:', email);
      this.onChangeInvestmentType({ target: { value: this.investmentType?.getRawValue() } });
    });
    this.tokenAddress?.valueChanges.subscribe(selectedTokenAddress => {
      console.log('Token seleccionado:', selectedTokenAddress);
      this.onChangeInvestmentType({ target: { value: this.investmentType?.getRawValue() } });
    });
    this.investmentType?.valueChanges.subscribe(type => {
      this.onChangeInvestmentType({ target: { value: type } });
    });
  }

  createFormBuyThroughCompany() {
    return new FormGroup({
      amountTokens: new FormControl(null, [Validators.required]),
      emailUser: new FormControl(null, [Validators.required]),
      addressContractSeller: new FormControl(null),
      tokenAddress: new FormControl('', [Validators.required]),
      investmentType: new FormControl('', [Validators.required]),
      isPrivateSale: new FormControl(false),
    })
  }

  get amountTokens() { return this.formBuyThroughCompany?.get('amountTokens'); }
  get emailUser() { return this.formBuyThroughCompany?.get('emailUser'); }
  get addressContractSeller() { return this.formBuyThroughCompany?.get('addressContractSeller'); }
  get tokenAddress() { return this.formBuyThroughCompany?.get('tokenAddress'); }
  get investmentType() { return this.formBuyThroughCompany?.get('investmentType'); }
  get isPrivateSale() { return this.formBuyThroughCompany?.get('isPrivateSale'); }

  private loadTokens() {
    this.afs
      .collection('investments')
      .get()
      .subscribe((querySnapshot) => {
        this.availableTokens = querySnapshot.empty ? [] : querySnapshot.docs
          .map(doc => {
            const data = doc.data() as { tokensAddress?: string; nameTokens?: string; sellerAddress?: string, id:string };
            if (data.tokensAddress && data.sellerAddress) {
              this.tokenToSellerMap[data.tokensAddress] = data.sellerAddress;
            }
            this.mappingId.set(data.tokensAddress, data.id);
            return {
              tokensAddress: data.tokensAddress ?? '',
              nameTokens: data.nameTokens ?? '',
              sellerAddress: data.sellerAddress ?? ''
            };
          })
          .filter(token => token.tokensAddress.trim() !== '' && token.nameTokens.trim() !== '' && token.sellerAddress?.trim() !== '');

        console.log('Tokens disponibles:', this.availableTokens);
        console.log('Mapa token -> seller:', this.tokenToSellerMap);
      }, (error) => {
        console.error("Error al cargar los tokens: ", error);
        this.availableTokens = [];
      });
  }

  onChangeInvestmentType(event: any) {
    const selectedType = event.target.value;
    this.isExternalChecked = selectedType === this.investmentTypeExternal;
    this.externalCanReserve = false;
    this.nonExternalCanProceed = false;
    this.externalCheck = '';

    if (this.isExternalChecked) {
      const email = this.emailUser?.getRawValue();
      const tokenName = this.availableTokens.find((token)=> token.tokensAddress === this.tokenAddress?.getRawValue())?.nameTokens;
      const tokens = this.amountTokens?.getRawValue();
      if(tokens<=0){
        this.externalCheck = 'La cantidad de tokens debe ser mayor que 0';
        return;
      }
      if(!email || !tokenName || !tokens){
        this.externalCheck = 'Debe completar todos los campos para reservar una inversión externa';
        return;
      }
      this.paymentService.checkExternalInvestment(email, tokenName, tokens).then((res: any) => {
        if (!res.result && res.amount != null && res.walletAmount != null) {
          const magnitude = Math.max(Math.abs(res.amount), Math.abs(res.walletAmount));
          const relTolerance = magnitude * 1e-9;
          if (res.amount - res.walletAmount <= relTolerance) {
            res.result = true;
          }
        }
        const displayAmount = res.amount != null ? parseFloat(res.amount.toFixed(4)) : res.amount;
        const displayWalletAmount = res.walletAmount != null ? parseFloat(res.walletAmount.toFixed(4)) : res.walletAmount;
        this.externalCheck = `${res.message}. ( ${res.tokens} / ${res.availableTokens} tokens | ${displayAmount} / ${displayWalletAmount} EUR)`;
        this.externalCanReserve = res.result;
        this.externalCheckResult = res;
      });
    } else if (selectedType) {
      this.checkNonExternalAvailability();
    }
  }

  private checkNonExternalAvailability() {
    const tokenAddr = this.tokenAddress?.getRawValue();
    const tokens = this.amountTokens?.getRawValue();

    if (!tokenAddr || !tokens) {
      this.externalCheck = 'Debe completar todos los campos para validar tokens disponibles';
      this.nonExternalCanProceed = false;
      return;
    }

    if (tokens <= 0) {
      this.externalCheck = 'La cantidad de tokens debe ser mayor que 0';
      this.nonExternalCanProceed = false;
      return;
    }

    const tokenId = this.mappingId.get(tokenAddr);
    if (!tokenId) {
      this.externalCheck = 'Token no encontrado';
      this.nonExternalCanProceed = false;
      return;
    }

    this.afs.collection('investments').doc(tokenId).get().subscribe((doc: any) => {
      if (!doc?.exists) {
        this.externalCheck = 'Proyecto no encontrado';
        this.nonExternalCanProceed = false;
        return;
      }

      const data = doc.data() as any;
      const amountToSell = Number(data?.amountToSell || 0);
      const amountSold = Number(data?.amountSold || 0);
      const reserves = Number(data?.reserves || 0);
      const privatePct = Number(data?.percentageToPrivateSale || 0);
      const sellCap = data?.onlyInversors ? Math.floor(amountToSell * (privatePct / 100)) : amountToSell;
      const available = Math.max(sellCap - (amountSold + reserves), 0);
      this.nonExternalCanProceed = available >= tokens;
      if (this.nonExternalCanProceed) {
        this.externalCheck = `Tokens disponibles: ${available}`;
      } else {
        this.externalCheck = `No hay tokens disponibles. (${tokens} / ${available} tokens)`;
      }
    });
  }

  async buy() {
    if (this.formBuyThroughCompany.invalid) {
      this.formBuyThroughCompany.markAllAsTouched();
      return;
    }

    const amount = this.amountTokens?.getRawValue();
    const tokenAddr = this.tokenAddress?.getRawValue();
    const userEmail = this.emailUser?.getRawValue();

    if (!amount || !tokenAddr) {
      Swal.close();
      Swal.fire({ icon: 'error', title: 'Error', text: 'Debe completar todos los campos antes de continuar' });
      return;
    }

    const selectedInvestmentType = this.investmentType?.getRawValue();
    if (!this.isExternalChecked && !this.nonExternalCanProceed) {
      Swal.close();
      Swal.fire({ icon: 'error', title: 'Error', text: 'No hay tokens disponibles para la cantidad solicitada' });
      return;
    }
    const confirmationHtml = this.getConfirmationHtml(selectedInvestmentType, amount, userEmail);

    // 🔔 CONFIRMACIÓN DE INVERSIÓN
    let timerInterval: any;
    const confirmResult = await Swal.fire({
      title: 'Confirmar Inversión',
      html: confirmationHtml,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, confirmar',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        if (!confirmButton) {
          return;
        }
        confirmButton.disabled = true;
        let remaining = 5;
        confirmButton.textContent = `Sí, confirmar (${remaining})`;
        timerInterval = setInterval(() => {
          remaining -= 1;
          if (remaining > 0) {
            confirmButton.textContent = `Sí, confirmar (${remaining})`;
            return;
          }
          clearInterval(timerInterval);
          confirmButton.textContent = 'Sí, confirmar';
          confirmButton.disabled = false;
        }, 1000);
      },
      willClose: () => {
        if (timerInterval) {
          clearInterval(timerInterval);
        }
      }
    });

    if (!confirmResult.isConfirmed) {
      return; // Usuario canceló la operación
    }

    await this.executeInvestmentByType(selectedInvestmentType, amount, tokenAddr, userEmail);
  }

  private getConfirmationHtml(
    investmentType: string | null | undefined,
    amount: number,
    userEmail: string
  ) {
    const baseMessage = `¿Estás seguro de que quieres registrar una inversión de <strong>${amount}</strong> tokens al usuario <strong>${userEmail}</strong>?`;
    let detailMessage = '';

    switch (investmentType) {
      case this.investmentTypeExternal:
        detailMessage = 'Este metodo enviara tokens y creara una transaccion de mangopay utilizando los fondos de la cartera de reserva.';
        break;
      case this.investmentTypeFailedMint:
        detailMessage = 'Este metodo enviara tokens sin registrar o generar alguna transaccion en mangopay.';
        break;
      case this.investmentTypeNoChargeTx:
        detailMessage = 'Este metodo enviara tokens registrando una transaccion ficticia en mangopay sin generar cobro alguno de la cartera de reservas.';
        break;
      case this.investmentTypeForcedTransferResend:
        detailMessage = 'Este metodo enviara los tokens usando el metodo buyWithoutPay del contrato, Ejecutarse solo cuando los tokens a enviar son por transferencia forzada.';
        break;
      default:
        detailMessage = '';
        break;
    }

    if (!detailMessage) {
      return baseMessage;
    }

    return `${baseMessage}<br><br>${detailMessage}`;
  }

  private async executeInvestmentByType(
    investmentType: string | null | undefined,
    amount: number,
    tokenAddr: string,
    userEmail: string
  ) {
    switch (investmentType) {
      case this.investmentTypeExternal:
        await this.handleExternalInvestment(amount);
        break;
      case this.investmentTypeFailedMint:
        await this.handleFailedMint(amount, tokenAddr, userEmail);
        break;
      case this.investmentTypeNoChargeTx:
        await this.handleNoChargeTransaction(amount, tokenAddr, userEmail);
        break;
      case this.investmentTypeForcedTransferResend:
        await this.handleForcedTransferResend(amount, tokenAddr, userEmail);
        break;
      default:
        return;
    }
  }

  private async handleExternalInvestment(amount: number) {
    const externalCheckResult = this.externalCheckResult;
    if (!externalCheckResult?.userId || !externalCheckResult?.projectId) {
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo validar la inversión externa. Revisa los datos.' });
      return;
    }
    
    Swal.fire({
      title: 'Procesando...',
      html: 'No cierres esta pantalla!!',
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });

    const isPrivateSale = this.isPrivateSale?.value || false;
    
    this.fns.httpsCallable('mintTokenWithoutPay')({
      userId: externalCheckResult.userId,
      projectId: externalCheckResult.projectId,
      totalTokens: amount,
      isExternal: true,
      isPrivateSale: isPrivateSale,
      idempotencyKey: crypto?.randomUUID ? crypto.randomUUID() : (Math.random().toString(36).substring(2, 15) + Date.now().toString(36)),
    }).subscribe({
      next: async (res: any) => {
        if (!res.success) {
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: res.error
          });
        } else {
          Swal.close();
          Swal.fire({
            icon: 'success',
            title: 'Inversión externa',
            text: 'Inversión externa realizada con éxito'
          });
          this.investmentType?.setValue('');
          this.formBuyThroughCompany.reset();
          this.externalCheck = '';
          this.externalCheckResult = null;
          this.isExternalChecked = false;
        }
      },
      error: (error: any) => {
        console.error('Error en inversión externa:', error);
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al procesar la inversión externa'
        });
      }
    });
    
    this.onChangeInvestmentType({ target: { value: this.investmentType?.getRawValue() } });
  }

  private async handleNoChargeTransaction(amount: number, tokenAddr: string, userEmail: string) {
    await this.handleMintOperation(amount, tokenAddr, userEmail, 'no-charge-tx', 'Inversión registrada');
  }

  private async handleForcedTransferResend(amount: number, tokenAddr: string, userEmail: string) {
    await this.handleMintOperation(amount, tokenAddr, userEmail, 'forced-transfer-resend', 'Tokens reenviados');
  }

  private async handleFailedMint(amount: number, tokenAddr: string, userEmail: string) {
    await this.handleMintOperation(amount, tokenAddr, userEmail, 'mint-only', 'Token acuñado');
  }

  private async handleMintOperation(
    amount: number,
    tokenAddr: string,
    userEmail: string,
    mintMode: 'mint-only' | 'no-charge-tx' | 'forced-transfer-resend',
    successTitle: string,
  ) {
    const now = Date.now();
    const sellerAddress = this.tokenToSellerMap[tokenAddr];
    const isPrivateSale = this.isPrivateSale?.value || false;
    if (!this.mappingId.has(tokenAddr)) {
      Swal.close();
      Swal.fire({ icon: 'error', title: 'Error', text: 'Token no encontrado' });
      return;
    }
    const tokenId = this.mappingId.get(tokenAddr);
    if (!sellerAddress) {
      Swal.close();
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo encontrar la dirección del contrato vendedor para el token seleccionado' });
      return;
    }

    Swal.fire({
      title: 'Procesando...',
      html: 'No cierres esta pantalla!!',
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });

    this.afs.collection('users', ref => ref.where('email', '==', userEmail).limit(1)).get().subscribe((res: any) => {
      if (!res.docs[0]?.exists) {
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Usuario no encontrado'
        });
      } else {
        const uid = res.docs[0].id;
        const userData = res.docs[0].data();
        if(userData?.kyc?.result != 1){
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Usuario no tiene KYC completado'
          });
          return;
        }
        if((!userData?.particular && !userData?.particular?.pais_de_residencia) && !userData?.Empresa?.Representante?.pais_de_residencia){
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Usuario con irregularidades'
          });
          return;
        }
        this.fns.httpsCallable('newWalletByCompany')({userUid: uid}).subscribe(async (res: any) => {
          if (!res.success) {
            Swal.close();
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: res.error
            });
          } else {
            try {
              const baseFee: number = await this.web3.eth.getBlock('pending').then((block: any) => {
                return Number(block.baseFeePerGas) + 100000000000;
              });

              console.log('Intentando invertir con:', {
                userAddress: res.address,
                sellerAddress: sellerAddress,
                tokenAddress: tokenAddr,
                amount: amount,
                ourAddress: this.ourAddress,
                mintMode: mintMode
              });
              this.fns.httpsCallable('mintTokenWithoutPay')({
                userId: uid,
                projectId: tokenId,
                totalTokens: amount,
                mintMode: mintMode,
                isPrivateSale: isPrivateSale,
                idempotencyKey: crypto?.randomUUID ? crypto.randomUUID() : (Math.random().toString(36).substring(2, 15) + Date.now().toString(36)),
              }).subscribe({
                next:async (res: any) => {
                if (!res.success) {
                  Swal.close();
                  Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: res.error
                  });
                } else {
                  Swal.close();
                  Swal.fire({
                    icon: 'success',
                    title: successTitle
                  })
                  this.formBuyThroughCompany.reset();
                  this.externalCheck = '';
                  this.externalCheckResult = null;
                  this.isExternalChecked = false;
                }
              },
                error: (error: any) => {
                  console.error('Error al acuñar el token:', error);
                  Swal.close();
                  Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al acuñar el token'
                  });
                }})
              return;
            
            } catch (error: any) {
              console.error('Error en la transacción:', error);
              await this.afs.collection('reserves-blockchain').doc(`${now}`).set({
                status: 'FAILED',
                reason: 'ERROR'
              }, { merge: true });
              Swal.close();
              Swal.fire({
                icon: 'error',
                title: 'Transacción errónea',
                text: 'Algo ha ido mal, la transacción NO se ha realizado. Error: ' + (error.message || 'Desconocido')
              });
            }
          }
        });
      }
    });
  }

  formatToWei(num: number) {
    return this.web3.utils.toWei(num.toString(), 'ether');
  }
}
